import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import getPermissions from './Permissions';
import _ from 'lodash';


export const FULL_ACCESS_USERS = ['admin1@vibino.ir', 'admin2@vibino.ir', 'admin1@gmail.com'];
export const isFullAccessUser = user => FULL_ACCESS_USERS.includes((user || '').toLowerCase());

const CheckPermission = (props) => {
    const permissions = getPermissions();
    const role = useSelector(state => state.authentication.user.role);
    const group = useSelector(state => state.authentication.user.group);
    const user = useSelector(state => state.authentication.user.username);
    let couldShow;
    if ((role || '').toLowerCase() === 'admin' || isFullAccessUser(user)) {
        couldShow = true;
    } else if (props.resource) {
        couldShow = _.find(permissions, function (o) {
            if (!props.group || props.group === group) {
                if ((props.allowed && !props.group) || (props.allowed && props.group === group))
                    return o.role === role && o.resource === props.resource && o.action.includes(props.action) && (o.attributes.includes(props.allowed) || o.attributes === '*')
                else
                    return o.role === role && o.resource === props.resource && o.action.includes(props.action)
            } else {
                return false;
            }
        })
    } else {
        couldShow = false;
    }
    // const couldShow = permissions.includes(props.permission);
    const showAll = permissions.includes('FULL_PERMISSION');
    // const couldShow = props.userPermissions.includes(props.permission);
    // const showAll = props.userPermissions.includes('FULL_PERMISSION');
    return (couldShow || showAll) ? props.children : null;
};

CheckPermission.propTypes = {
    resource: PropTypes.string.isRequired,
    action: PropTypes.array.isRequired,
};


export default CheckPermission;
